import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Button, TextField } from '@mui/material';

import './../styles/cart-buttons.css'
import { useIsOutOfStock } from '../utils/helpers';

function CartButtons({ addToCart, quantity, setQuantity }) {
  const isOutOfStock = useIsOutOfStock(window?.conspire_product?.tags);
  const atcButtonText = isOutOfStock ? 'Out of Stock' : 'Add to Cart';

  const increaseQuantity = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
  }
  const decreaseQuantity = () => {
    const newQuantity = quantity - 1;

    if (newQuantity >= 0) {
      setQuantity(newQuantity);
    }
  }

  const handleQuantityChange = (e) => {
    const newQuantity = e.target.value;

    if (newQuantity >= 0) {
      setQuantity(newQuantity);
    }
  }

  return (
    <section className='cart-buttons-wrapper'>
      <Grid container className="cart-buttons-container">
        <Grid item xs={6}>
          <div className="quantity-selector">
            <Button variant="contained" onClick={decreaseQuantity} className="quantity-button">
              -
            </Button>
            <TextField
              id="quantity-input-field"
              type="numeric"
              InputLabelProps={{
                shrink: true,
              }}
              className="quantity-input"
              value={quantity}
              onChange={handleQuantityChange}
            />
            <Button variant="contained" onClick={increaseQuantity} className="quantity-button">
              +
            </Button>
          </div>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={addToCart}
            className={`add-to-cart-button ${isOutOfStock ? 'disabled' : ''}`}
            disabled={isOutOfStock}
          >
            {atcButtonText}
          </Button>
        </Grid>
      </Grid>
    </section>
  )
}

export default CartButtons
